import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

interface ManualScoreResponse {
  success: boolean;
  message: string;
  questionId: string;
  periodsGraded: number;
  periods: Array<{
    periodCode: string;
    winningSquareNumber: number;
    rowTeamScore: number;
    colTeamScore: number;
    rowLastDigit: number;
    colLastDigit: number;
  }>;
}

export async function manualScoreSquare(squareId: string): Promise<ManualScoreResponse> {
  const response = await (apiClient as any).post(`/api/admin/squares/${squareId}/manual-score`);
  return response as ManualScoreResponse;
}

export function useManualScoreSquareMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: manualScoreSquare,
    onSuccess: data => {
      toast.success(data.message || `Successfully scored ${data.periodsGraded} period(s)`);
      // Invalidate squares queries to refresh data
      queryClient.invalidateQueries({ queryKey: queryKeys.squares.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.squares.detail(data.questionId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.squares.periodResults(data.questionId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.squares.entries(data.questionId) });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.error || error?.message || 'Failed to score Squares contest';
      toast.error(errorMessage);
    },
  });
}
